__turbopack_context__.v({
  "avatar": "styles-module-scss-module__MWuoUq__avatar",
  "centerText": "styles-module-scss-module__MWuoUq__centerText",
  "container": "styles-module-scss-module__MWuoUq__container",
  "content": "styles-module-scss-module__MWuoUq__content",
  "media": "styles-module-scss-module__MWuoUq__media",
  "textFirst": "styles-module-scss-module__MWuoUq__textFirst",
  "videoContentOverlap": "styles-module-scss-module__MWuoUq__videoContentOverlap",
  "videoZoom": "styles-module-scss-module__MWuoUq__videoZoom",
});
